// GitInfoPage.js
import React from 'react';
import ReusableGitInfoPage from '../../b2b-common/pages/ReusableGitInfoPage';
import { fetchGitUserData } from '../../../services/b2b-users-apiService'

const GitInfoPage = () => {
    return (
        <ReusableGitInfoPage bannerMessage="Users Menu: Show Git commit info." fetchMethod={fetchGitUserData} />
    );
};

export default GitInfoPage;
